// LOT 2 — Client admin pour la queue de relecture EC.
//
// Token conservé en sessionStorage (jamais persisté après fermeture de l'onglet).
// Toutes les requêtes envoient l'entête X-Admin-Token.

const API = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "pcg_admin_token";

export const getAdminToken = () => sessionStorage.getItem(TOKEN_KEY) || "";
export const setAdminToken = (t) => sessionStorage.setItem(TOKEN_KEY, t);
export const clearAdminToken = () => sessionStorage.removeItem(TOKEN_KEY);

function headers() {
  return {
    "Content-Type": "application/json",
    "X-Admin-Token": getAdminToken(),
  };
}

/** Récupère un bucket de la queue. bucket ∈ {"all","urgent","normal","metadata"}. */
export async function fetchQueue({ bucket = "all", gravite, offset = 0, limit = 50 } = {}) {
  const params = new URLSearchParams({ bucket, offset: String(offset), limit: String(limit) });
  if (gravite) params.set("gravite", gravite);
  const res = await fetch(`${API}/api/admin/accounts/queue?${params}`, { headers: headers() });
  if (res.status === 401) throw new Error("UNAUTHORIZED");
  if (!res.ok) throw new Error(`Queue fetch failed: HTTP ${res.status}`);
  return res.json();
}

/** Contresigne une fiche. verifiedBy = ex. "K.T.". Un geste = une fiche. */
export async function verifyAccount(num, verifiedBy) {
  const res = await fetch(`${API}/api/admin/accounts/${encodeURIComponent(num)}/verify`, {
    method: "POST",
    headers: headers(),
    body: JSON.stringify({ verified_by: verifiedBy }),
  });
  if (res.status === 401) throw new Error("UNAUTHORIZED");
  if (res.status === 409) throw new Error("ALREADY_VERIFIED");
  if (res.status === 404) throw new Error("NOT_FOUND");
  if (!res.ok) throw new Error(`Verify failed: HTTP ${res.status}`);
  return res.json();
}

/** Retire la contresignature. La raison est obligatoire (min 5 chars) et journalisée. */
export async function unverifyAccount(num, unverifiedBy, reason) {
  const res = await fetch(`${API}/api/admin/accounts/${encodeURIComponent(num)}/unverify`, {
    method: "POST",
    headers: headers(),
    body: JSON.stringify({ unverified_by: unverifiedBy, reason }),
  });
  if (res.status === 401) throw new Error("UNAUTHORIZED");
  if (res.status === 409) throw new Error("NOT_VERIFIED");
  if (res.status === 404) throw new Error("NOT_FOUND");
  if (res.status === 422) throw new Error("VALIDATION");
  if (!res.ok) throw new Error(`Unverify failed: HTTP ${res.status}`);
  return res.json();
}

/** Journal immuable des contresignatures et levées. */
export async function fetchJournal({ num, actor, action, offset = 0, limit = 100 } = {}) {
  const params = new URLSearchParams({ offset: String(offset), limit: String(limit) });
  if (num) params.set("num", num);
  if (actor) params.set("actor", actor);
  if (action) params.set("action", action);
  const res = await fetch(`${API}/api/admin/accounts/journal?${params}`, { headers: headers() });
  if (res.status === 401) throw new Error("UNAUTHORIZED");
  if (!res.ok) throw new Error(`Journal fetch failed: HTTP ${res.status}`);
  return res.json();
}

/** Télécharge le zip des exports GPT (protégé par token admin).
 *  Récupère le blob puis déclenche un download natif via un <a download> temporaire.
 */
export async function downloadExportsZip() {
  const res = await fetch(`${API}/api/admin/accounts/exports/zip`, { headers: headers() });
  if (res.status === 401) throw new Error("UNAUTHORIZED");
  if (!res.ok) throw new Error(`Exports zip failed: HTTP ${res.status}`);
  const blob = await res.blob();
  const cd = res.headers.get("content-disposition") || "";
  const match = cd.match(/filename="([^"]+)"/);
  const filename = match ? match[1] : "pcg-exports.zip";
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
  return { filename, size: blob.size };
}
